/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 头像样式
   */
  avatar_image_type: string;
}
export type OrgList = {
  /**
   * 主办方ID
   */
  host_id: number | string;
  /**
   * 主办方名字
   */
  host_name: string;
  /**
   * 主办方头像url
   */
  host_avatar_url: string;
  /**
   * 主办方头像cos_id
   */
  host_avatar_cos_id: string;
  /**
   * 手机区号
   */
  area_code: string;
  phone: string;
  email: string;
  /**
   * 角色ID
   */
  role_id: number;
  /**
   * 状态，0未启用，1已启用
   */
  status: number;
}[];
export interface DashboardOrgGetUserHostOrgListRes {
  code?: number;
  msg?: string;
  nonce?: string;
  data: Data;
}
export interface Data {
  org_list: OrgList;
  /**
   * 被选中的主办方ID
   */
  selected_host_id: number;
}

const DashboardOrgGetUserHostOrgList = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardOrgGetUserHostOrgListRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/org/get-user-host-org-list',
    data,
    ctx,
  );

  return res;
};

export default DashboardOrgGetUserHostOrgList;
